export const colorIntersection = [
    { index: 1, color: "#90D14F" },
    { index: 2, color: "#01B051" },
    { index: 3, color: "#01B0EF" },
    { index: 4, color: "#0C70BE" },
    { index: 5, color: "#6F2FA1" },
    { index: 6, color: "#FE31CC" },
    { index: 7, color: "#FF4F52" },
    { index: 8, color: "#FF0300" },
];
